<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
            <div class="container">
                <div class="page-banner-content">
                    <h1>Code of Conduct</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Student Corner</li>
                        <li>Policies</li>
                        <li>Code of Conduct</li>
                    </ul>
                </div>
            </div>
        </div>
        <!--End Page Banner-->

        <!--Start Best Practise Area-->
        <div class="privacy-policy-area pt-100 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="privacy-content pr-20">
                            <h2>Code of Conduct for Students</h2>
                            <p>Please read this Code of Conduct carefully </p>

                            <div class="list">
                                <ul>
                                    <li><i class="ri-checkbox-line"></i>The institute’s works on the ideology of “No
                                        Profit- No Loss”.</li>
                                    <li><i class="ri-checkbox-line"></i>All over development of the students is done
                                        with the help of extra
                                        curricular activities in college.</li>
                                    <li><i class="ri-checkbox-line"></i>Transparent admission process. Financial
                                        assistance like -rebate in fee
                                        ( for sports,percentage base,BPL rebate) or free studentship is granted to
                                        the needy students.</li>
                                    <li><i class="ri-checkbox-line"></i>College provided free of cost uniform to each
                                        enrolled student and
                                        wearing college uniform is compulsory in college.
                                    </li>
                                    <li><i class="ri-checkbox-line"></i>Students must carry their identity card while
                                        inside the campus.In case
                                        of loss of identity card ,a duplicate can be obtained only with the
                                        permission of the principal and on payment of a fine Rs.100/.</li>
                                    <li><i class="ri-checkbox-line"></i>Students falling to wear college ID card shall
                                        not be allowed to enter
                                        college premises.</li>
                                    <li><i class="ri-checkbox-line"></i>Enrich library facility with number of text and
                                        reference books.
                                        Book bank provides books to the needy students at nominal charges for
                                        whole academic year which is return after deposition of books.</li>

                                    <li><i class="ri-checkbox-line"></i>The mentor -Mentee system has been started in
                                        college to inculcate
                                        confidence in the students.Around 1696 students were enrolled in this
                                        programme.</li>
                                    <li><i class="ri-checkbox-line"></i>Students must have maximum attendance to be
                                        permitted to take up
                                        annual examination . If a students is absent without inform in college for
                                        more than two weeks her name is likely to be struck off from the register.</li>
                                    <li><i class="ri-checkbox-line"></i>Students are required to get themselves updated
                                        regularly by reading
                                        the noticeboard and reading the handbook .Rules for the conduct of
                                        examination placed on notice board must be strictly observed.</li>

                                    <li><i class="ri-checkbox-line"></i>Using of mobile phones inside the class room
                                        during class hours is
                                        strictly prohibited and liable to penalty .</li>
                                    <li><i class="ri-checkbox-line"></i>Students must be present in their classes and
                                        take their seat at the
                                        beginning of each period ,they must not leave the classroom without the
                                        concerned professor permission.</li>
                                    <li><i class="ri-checkbox-line"></i>Vedanta college is a ragging free campus..Any
                                        form of ragging is
                                        strictly prohibited and any students found to be involved in ragging of
                                        any nature ,will be liable to serve disciplinary action as per law.</li>
                                    <li><i class="ri-checkbox-line"></i>Students representative were selected from every
                                        classes .They were
                                        selected on the base of their all over participation and performance in
                                        curricular ,co-curricular activities ,interest need & concern of the fellow
                                        students whose serve as a voice for the student body.</li>
                                </ul>
                            </div>

                            <h2>Code of Conduct for Teachers</h2>
                            <p>Please read this Code of Conduct carefully </p>

                            <div class="list">
                                <ul>
                                    <li><i class="ri-checkbox-line"></i>Faculty should involve themselves in active
                                        teaching & all over
                                        development of the students.</li>
                                    <li><i class="ri-checkbox-line"></i>Faculty should complete the syllabus in time.
                                    </li>
                                    <li><i class="ri-checkbox-line"></i>Faculty should be good councilor and
                                        facilater.They should help
                                        guide,encourage and assist the students to encourage that the teaching
                                        learning process is effective and successful.</li>
                                    <li><i class="ri-checkbox-line"></i>Faculty should maintain the attendance register
                                        and teaching diaries
                                        regularly.
                                    </li>
                                    <li><i class="ri-checkbox-line"></i>Biometric machines is being used for attendance
                                        of staff to develop
                                        punctuality among them.</li>
                                    <li><i class="ri-checkbox-line"></i>Every confirmed lady teaching staff will be
                                        eligible for maternity
                                        leave of a maximum of 180 days during her entire period of service.</li>
                                    <li><i class="ri-checkbox-line"></i>Lecturers use innovative teaching methods so
                                        that students' attention
                                        can be attracted towards the subject.( Like use of model & charts,poster
                                        making competition).</li>

                                    <li><i class="ri-checkbox-line"></i>Take leave as per the rules of the College with
                                        assigned their classes to
                                        other staff members.</li>
                                </ul>
                            </div>

                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="privacy-left-content pl-20">
                            <div class="team-img-box"> <img width="460" height="500"
                                    src="/vf/images/policies/code_conduct.png"
                                    class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                    decoding="async" fetchpriority="high"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--End Anti Ragging Area-->


        <!-- Start Bottom Connect Area -->
        <div class="alumni-interview-area pb-100">
        <div class="container">
            <div class="interview-content ptb-100">
                <div class="interview">
                    <router-link to="antiragging" class="default-btn btn">Mentor Mentee<i
                            class="flaticon-next"></i></router-link>
                    <router-link  to="/applynow" class="default-btn btn">Apply Now</router-link>
                </div>
            </div>
        </div>
    </div>
        <!--End Bottom Connect Area -->
</template>

<script>
export default {
    name : "AntiRaggingView"
};
</script>
